import React from "react";
import classNames from "classnames";
import { IconProps, IconDimensions } from "../../types";
import { getIconDimensions } from "../../../utils/icon-utils";

export const IconCheckboxUnchecked = ({
  title,
  titleId,
  color,
  className: classNameProp,
  size,
  height,
  width,
  ...restProps
}: IconProps) => {
  const className = classNames(
    {
      [`text-${color}`]: color !== undefined,
    },
    classNameProp
  );

  const defaultDimensions: IconDimensions = {
    height: 24,
    width: 24,
  };
  const props = {
    className,
    ...getIconDimensions(size, width, height, defaultDimensions?.width, defaultDimensions?.height),
    ...restProps,
  };

  return (
    <svg fill="currentcolor" viewBox="0 0 24 24" {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        d="M19 3c1.1 0 2 .9 2 2h0v14c0 1.1-.9 2-2 2h0H5c-1.1 0-2-.9-2-2h0V5c0-1.1.9-2 2-2h0Zm-1 2H6a1 1 0 00-1 1h0v12a1 1 0 001 1h12a1 1 0 001-1h0V6a1 1 0 00-1-1h0Z"
      />
    </svg>
  );
};

IconCheckboxUnchecked.displayName = "IconCheckboxUnchecked";
